import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import MainContent from "/component/layout/MainContent";
import { useTranslation } from "/hook";
import { reactPlugin } from "/util/appInsights.util";

import DocumentSegmentedControl from "./components/DocumentSegmentedControl";
import DocumentsInOffice from "./components/DocumentsInOffice";
import DocumentsVideo from "./components/DocumentsVideo";

const Documents = () => {
  const { t } = useTranslation("documents");

  const [selectedControl, setSelectedControl] = useState<string>("inOffice");

  const handleSelectedControl = (control: string | undefined) => {
    if (control) {
      setSelectedControl(control);
    }
  };

  const DocumentsContent = () => {
    if (selectedControl === "video") {
      return <DocumentsVideo />;
    }

    return <DocumentsInOffice />;
  };

  return (
    <MainContent pageTitle={t("pageTitle")} parentPage="myHealth">
      <Helmet>
        <title>{t("pageTitle")}</title>
      </Helmet>

      <DocumentSegmentedControl onItemSelected={handleSelectedControl} value={selectedControl} />
      <DocumentsContent />
    </MainContent>
  );
};

export default withAITracking(reactPlugin, Documents, undefined, "ai-tracking");
